import { getItemQuery } from '@/graphql';
import { setUpGraphQLClient } from '@/lib/graphql/client';
import { GQItemQueryResult } from '@/types/graphql';
import { ScItem } from '@/types/sitecore';

export const getItem = async <T>(path: string) => {
  const query = getItemQuery(path);
  const client = setUpGraphQLClient('master');
  const res = await client.request<GQItemQueryResult<any>>(query);
  const fields: Record<string, any> = {};
  res.item.allFields.forEach((it: any) => {
    fields[it.name] = it.value;
  });
  return {
    id: res.item.id,
    name: res.item.name,
    displayName: res.item.displayName,
    fields,
  } as ScItem<T>;
};
